import React, { FC } from 'react'
import { Route } from 'react-router-dom'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { UserSettingsDesktop } from './UserSettingsDesktopPage'
import { UserSettingsMobile } from './UserSettingsMobilePage'

export const UserSettingsIndexPage: FC = () => {
  const { isMobile } = useBreakpointContext()

  if (isMobile) {
    return (
      <Route
        path={[
          '/user/settings/date-time',
          '/user/settings/name',
          '/user/settings/change-password',
          '/user/settings/carrier-profiles',
          '/user/settings/eld-integrations',
          '/user/settings/email-preferences',
          '/user/settings/account-deletion-warning',
          '/user/settings',

          // FIXME: this is only needed because some logic is redirecting from `/user/settings` to `/user/settings/general`, sometimes
          '/user/settings/general',
        ]}
        requiresOnboarding
        exact>
        <UserSettingsMobile />
      </Route>
    )
  }

  return (
    <Route
      requiresOnboarding
      exact
      path={[
        '/user/settings/general',
        '/user/settings/profile',
        '/user/settings/organization',
        '/user/settings/carrier-profiles',
        '/user/settings/integrations',
        '/user/settings/notifications',
        '/user/settings',
      ]}>
      <UserSettingsDesktop />
    </Route>
  )
}

export default UserSettingsIndexPage
